import PracticePage from "@/components/PracticePage";
import CTABanner from "@/components/CTABanner";
import FAQ from "@/components/FAQ";
import { useSEO } from "@/lib/seo";

export default function BusinessLaw() {
    useSEO({
        title: "Business Law Attorneys | LLCs, Contracts & Family Enterprises",
        description:
            "Business law for family enterprises, farms, and Main-Street companies. Formation, contracts, and ongoing counsel.",
        path: "/business-law",
        schema: {
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Business Law",
            provider: { "@type": "LegalService", name: "Chesterton" }
        }
    });

    return (
        <>
            <PracticePage
                slug="business-law"
                kicker="Practice · Business Law"
                title={<>Build the business once. Build it right.</>}
                lede="From a one-tractor sole proprietorship to a multi-entity family operation, the legal structure of your business decides how taxes flow, how liability is contained, and how the next generation steps in. We help owners get it set up, and keep it tidy."
                heroImg="https://images.unsplash.com/photo-1756638447144-cfaa1dea21f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxydXJhbCUyMGZhcm0lMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzc5ODMzMzMwfDA&ixlib=rb-4.1.0&q=85"
                bullets={[
                    "LLC and corporation formation",
                    "Nonprofit and ministry formation, including 501(c)(3)",
                    "Partnership and joint-venture structures",
                    "Operating agreements and bylaws",
                    "Buy-sell and shareholder agreements",
                    "Vendor, customer, and service contracts",
                    "Employment letters and contractor agreements",
                    "Commercial leases and equipment financing",
                    "Mergers, acquisitions, and dissolutions"
                ]}
                sections={[
                    {
                        h: "Formation that fits the operation.",
                        p: "A farm holding land, a contract-growing operation, a custom-harvest crew, a Main-Street retailer: each calls for a different structure. We talk through liability, tax, succession, and lender expectations before we file the first form."
                    },
                    {
                        h: "Operating agreements that actually answer the hard questions.",
                        p: "Most off-the-shelf operating agreements look fine until something happens: a death, a divorce, a falling out, an investor. Ours spell out voting, buyouts, valuation, and exits so the next conversation is calm, not legal."
                    },
                    {
                        h: "Contracts in plain English, enforceable in court.",
                        p: "We draft and review the agreements that make a business run: vendor terms, customer agreements, leases, equipment financing, and employment documents. Clear, fair, and built to hold up over time."
                    },
                    {
                        h: "Ministries, churches, and mission-driven nonprofits.",
                        p: "We help clients form and organize churches, ministries, and mission-driven nonprofits from the ground up: state incorporation, IRS 501(c)(3) recognition (Form 1023 or 1023-EZ), bylaws and conflict-of-interest policies, board governance, and the ongoing compliance that keeps the mission unencumbered."
                    },
                    {
                        h: "Transitions, sales, and wind-downs.",
                        p: "When it’s time to bring in a partner, sell the business, or wind things down, we handle the deal documents and the close, and coordinate with your CPA to keep the tax side from biting."
                    }
                ]}
            />
            <FAQ />
            <CTABanner />
        </>
    );
}
